export const POSTS_PER_PAGE = 5;

export const POST_COMMENTS_PER_PAGE = 99;
